import './CardModal.scss'
import { ReactNode } from 'react'

interface Props {
    children: ReactNode
    onClose?: () => void
}

const CardModal = ({ children, onClose }: Props) => {
    return (
        <div className="smart-modals-card-modal">
            <div className="overlay">
                <div className="card">
                    <div className="close-button cursor-pointer" onClick={onClose}>
                        <i className="cu cu-times" style={{ color: 'var(--lux-black)' }} />
                    </div>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default CardModal
